/**
 * @flow
 * @relayHash 0b6253d69385a33302c711893be2af78
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteActionInput = {|
  clientMutationId?: ?string,
  context: MutationContext,
  actionId: string,
|};
export type MutationContext = {|
  organizationId: string
|};
export type DeleteActionMutationVariables = {|
  input: DeleteActionInput
|};
export type DeleteActionMutationResponse = {|
  +deleteAction: ?{|
    +deletedActionId: string
  |}
|};
export type DeleteActionMutation = {|
  variables: DeleteActionMutationVariables,
  response: DeleteActionMutationResponse,
|};
*/


/*
mutation DeleteActionMutation(
  $input: DeleteActionInput!
) {
  deleteAction(input: $input) {
    deletedActionId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteActionPayload",
    "kind": "LinkedField",
    "name": "deleteAction",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedActionId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteActionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteActionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "0b6253d69385a33302c711893be2af78",
    "metadata": {},
    "name": "DeleteActionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '5dc396ac5a0a1efb0ada9ec1e74fe407';

module.exports = node;
